import { render, staticRenderFns } from "./egame.vue?vue&type=template&id=39e3a2d3&"
import script from "./egame.vue?vue&type=script&lang=js&"
export * from "./egame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports